<template>
  <div class="container-fluid px-0">
    <script type="application/ld+json">
      {
        "@context": "http://schema.org",
        "@graph": [
          {
            "@type": "Article",
            "url": "https://www.teddi.co/etapes-achat-immobilier/",
            "headline": "Les étapes d'un achat immobilier ← Teddi",
            "description": "Tous nos conseils pour vivre les étapes de l'achat immobilier avec les
            meilleurs partenaires possibles.",
            "datePublished": "2020-06-14T17:47:50.000Z",
            "dateModified": "2020-06-15T09:20:51.000Z",
            "mainEntityOfPage": {
              "@type": "WebPage",
              "@id": "https://www.teddi.co/etapes-achat-immobilier/"
            },
            "publisher": {
              "@type": "Organization",
              "@id": "https://www.teddi.co/",
              "name": "Teddi",
              "logo": {
                "@type": "ImageObject",
                "url": "https://www.teddi.co/assets/socials/fb-profile.png",
                "width": 1000,
                "height": 1000
              }
            },
            "author": {
              "@type": "Person",
              "name": "Thomas"
            }
          }
        ]
      }
    </script>
    <div class="container timeline">
      <div class="row justify-content-center">
        <div class="title border-radius p-4 m-2 m-md-0">
          <h1 class="header__title">Les étapes d'un achat immobilier</h1>
          <h3 class="content__title">
            Tous nos conseils pour vivre les étapes de l'achat immobilier avec les meilleurs
            partenaires possibles.
          </h3>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 mx-auto">
          <b-img
            class="w-100"
            alt="teddi-hunter"
            :src="require('@/assets/img/teddi-hunter.svg')"
          ></b-img>
        </div>
      </div>
      <!--PEN CONTENT-->
      <div class="content">
        <!--content inner-->
        <div class="content__inner">
          <div class="timeline text-left">
            <!--timeline bar-->
            <div class="timeline__bar"></div>
            <!--timeline element-->
            <div class="timeline__elem timeline__elem--left">
              <!--timeline element date-->
              <div class="timeline__date">
                <IconSearch class="white icon" />
              </div>
              <!--timeline event-->
              <div class="timeline__event">
                <!--timeline event title-->
                <h4 class="timeline__event-title">Commencer sa recherche 🔍</h4>
                <!--timeline event descrtiption-->
                <div class="timeline__event-descr">
                  <ul>
                    <li>
                      J'ai le temps de m'en occuper : je configure une alerte Teddi pour recevoir
                      les biens en premier.
                    </li>
                    <li>
                      Je n'ai pas le temps : je fais appel à un chasseur partenaire de Teddi.
                    </li>
                  </ul>
                  <p>Que choisissez-vous ?</p>
                </div>
                <!--timeline event actions links-->
                <div class="timeline__event-actions">
                  <b-link class="timeline__event-action" :to="{ name: 'register' }" title="Teddi"
                    >Alerte</b-link
                  ><b-link
                    class="timeline__event-action"
                    :to="{ name: 'form-hunter' }"
                    title="Chasseur"
                    >Chasseur</b-link
                  >
                </div>
              </div>
            </div>
            <!--timeline element-->
            <!--  <div class="timeline__elem timeline__elem--right">
              <div class="timeline__date">
                <IconPrice class="white icon" />
              </div>
              <div class="timeline__event">
                <h4 class="timeline__event-title">Préparer son financement</h4>
                <div class="timeline__event-descr">
                  <p>
                    <strong class="text-blue">⚡️ Nouveau !</strong>
                  </p>
                  <p>
                    Je candidate automatiquement auprès de toutes les banques pour comparer les taux
                    qu'elles me proposent selon mon profil. C'est
                    <strong class="text-blue">gratuit</strong> ! 🌈
                  </p>
                  <p>
                    Avec le certificat de la banque, mon dossier a plus de chances d'être retenu que
                    les autres !
                  </p>
                </div>
                <div class="timeline__event-actions">
                  <b-link
                    v-if="email"
                    class="timeline__event-action"
                    @click="sendToPartnerBank"
                    title="Comparer"
                    >Comparer et obtenir un certificat</b-link
                  >
                  <b-link
                    v-else
                    @click="openModalEmail"
                    class="timeline__event-action"
                    title="Comparer"
                    >Comparer et obtenir un certificat</b-link
                  >
                </div>
              </div>
            </div> -->
            <!--timeline element-->
            <div class="timeline__elem timeline__elem--right">
              <!--timeline element date-->
              <div class="timeline__date">
                <IconRuler class="white icon" />
              </div>
              <!--timeline event-->
              <div class="timeline__event">
                <!--timeline event title-->
                <h4 class="timeline__event-title">Evaluer les travaux 📐</h4>
                <!--timeline event descrtiption-->
                <div class="timeline__event-descr">
                  <p>
                    Un appartement ou une maison que vous avez visité vous plaît et vous aimeriez
                    avoir l'avis d'un professionnel sur les travaux à faire ainsi qu'un devis ?
                  </p>
                  <p>
                    Demandez à notre partenaire dont les clients sont satisfaits à plus de 98% !
                  </p>
                </div>
                <!--timeline event actions links-->
                <div class="timeline__event-actions">
                  <b-link
                    class="timeline__event-action"
                    :to="{ name: 'form-refurbishment' }"
                    title="Comparer"
                    >Comparer</b-link
                  >
                </div>
              </div>
            </div>
            <!--timeline element-->
            <div class="timeline__elem timeline__elem--left">
              <!--timeline element date-->
              <div class="timeline__date">
                <IconEdit class="white icon" />
              </div>
              <!--timeline event-->
              <div class="timeline__event">
                <!--timeline event title-->
                <h4 class="timeline__event-title">Notaire 👩‍💼</h4>
                <!--timeline event descrtiption-->
                <div class="timeline__event-descr">
                  <p>
                    J'ai fait une offre sur un appartement qui a été acceptée 🌈 ! Je préviens mon
                    notaire qui se chargera de rédiger le compromis de vente et l'acte authentique.
                  </p>
                </div>
                <!--timeline event actions links-->
                <div class="timeline__event-actions">
                  <a
                    title="J'ai besoin d'un notaire"
                    class="timeline__event-action"
                    href="mailto:notary@teddi.co?subject=J'aimerais%20%C3%AAtre%20mis%20en%20relation%20avec%20un%C2%B7e%20notaire&body=Bonjour%2C%0D%0A%0D%0AJ'aimerais%20%C3%AAtre%20recontact%C3%A9%C2%B7e%20par%20votre%20notaire%20partenaire.%0D%0A%0D%0AMa%20demande%20concerne%20%3A%0D%0A%0D%0A-%20une%20transaction%20%3A%20achat%20ou%20vente%20%3F%0D%0A-%20autre%20%3A%0D%0A%0D%0ASi%20transaction%2C%20caract%C3%A9ristiques%20du%20bien%20%3A%0D%0A%0D%0A-%20adresse%20%3A%20%0D%0A-%20prix%20%3A%0D%0A-%20surface%20%3A%0D%0A-%20%C3%A9tage%20%3A%20%0D%0A%0D%0AMes%20informations%20personnelles%20%3A%0D%0A%0D%0AMon%20pr%C3%A9nom%20%3A%20%0D%0AMon%20nom%20%3A%0D%0AJ'aimerais%20qu'on%20me%20rappelle%20au%20%3A"
                    >J'ai besoin d'un notaire</a
                  >
                </div>
              </div>
            </div>
            <!--timeline element-->
            <div class="timeline__elem timeline__elem--right">
              <!--timeline element date-->
              <div class="timeline__date">
                <IconWrench class="white icon" />
              </div>
              <!--timeline event-->
              <div class="timeline__event">
                <!--timeline event title-->
                <h4 class="timeline__event-title">Faire les travaux 👷‍♂️</h4>
                <!--timeline event descrtiption-->
                <div class="timeline__event-descr">
                  <p>
                    Il n'est pas toujours facile de trouver le bon prestataire pour effectuer des
                    travaux de rénovation.
                  </p>
                  <p>
                    Pourquoi ne pas simplement les comparer en regardant les avis obtenus de leurs
                    clients ?
                  </p>
                </div>
                <!--timeline event actions links-->
                <div class="timeline__event-actions">
                  <b-link
                    class="timeline__event-action"
                    :to="{ name: 'form-refurbishment' }"
                    title="Comparer"
                    >Comparer</b-link
                  >
                </div>
              </div>
            </div>
            <!--  <div class="timeline__elem timeline__elem--left">
              <div class="timeline__date">
                <IconDirections class="white icon" />
              </div>
              <div class="timeline__event">
                <h4 class="timeline__event-title">Transfert de contrats</h4>
                <div class="timeline__event-descr">
                  <p>
                    Vous déménagez ? Nous nous occupons de transférer tous vos contrats : énergie,
                    internet, assurance, courrier. Tout en un et 100% gratuit !
                  </p>
                </div>
                <div class="timeline__event-actions">
                  <a class="timeline__event-action" href="#" title="Learn More"
                    >Transférer mes contrats</a
                  >
                </div>
              </div>
            </div> -->
            <!--timeline element-->
            <div class="timeline__elem timeline__elem--left">
              <!--timeline element date-->
              <div class="timeline__date">
                <IconMoving class="white icon" />
              </div>
              <!--timeline event-->
              <div class="timeline__event">
                <!--timeline event title-->
                <h4 class="timeline__event-title">Déménagement 🚚</h4>
                <!--timeline event descrtiption-->
                <div class="timeline__event-descr">
                  <p>
                    Nous mettons en concurrence les déménageurs certifiés de notre réseau national
                    de partenaires afin de vous proposer le meilleur rapport qualité-prix du marché.
                  </p>
                </div>
                <!--timeline event actions links-->
                <div class="timeline__event-actions">
                  <a
                    class="timeline__event-action"
                    title="Publier"
                    href="mailto:moving@teddi.co?subject=Comparer%20les%20d%C3%A9m%C3%A9nageurs&body=Bonjour%2C%0D%0A%0D%0AJ'aimerais%20trouver%20le%20meilleur%20d%C3%A9m%C3%A9nageur%20pour%20mon%20cas%20pr%C3%A9cis%20%3A%0D%0A%0D%0ALes%20caract%C3%A9ristiques%20de%20l'appartement%20ou%20la%20maison%20%3A%0D%0A%0D%0A-%20adresse%20de%20d%C3%A9part%20%3A%20%0D%0A-%20adresse%20d'arriv%C3%A9e%20%3A%20%0D%0A-%20%C3%A9tage%20de%20d%C3%A9part%20%3A%0D%0A-%20%C3%A9tage%20d'arriv%C3%A9e%20%3A%0D%0A-%20nombre%20de%20cartons%20de%20taille%20moyenne%20%3A%20%0D%0A-%20nombre%20de%20meubles%20lourds%20%3A%20%0D%0A-%20pr%C3%A9cisions%20%3A%0D%0A%0D%0AJ'aimerais%20recevoir%20les%20demandes%20d'informations%20%3A%0D%0A%0D%0A-%20%C3%A0%20l'email%20suivant%20%3A%0D%0A-%20au%20num%C3%A9ro%20suivant%20%3A%20"
                    >Comparer</a
                  >
                </div>
              </div>
            </div>
            <!--timeline element-->
            <div class="timeline__elem timeline__elem--right">
              <!--timeline element date-->
              <div class="timeline__date">
                <IconInsurance class="white icon" />
              </div>
              <!--timeline event-->
              <div class="timeline__event">
                <!--timeline event title-->
                <h4 class="timeline__event-title">Assurance 👩‍🚒</h4>
                <!--timeline event descrtiption-->
                <div class="timeline__event-descr">
                  <ul>
                    <li>
                      Résidence principale ou secondaire : je souscris à la meilleure offre
                      d'assurance habitation.
                    </li>
                    <li>
                      Investissement : je sous scris à la meilleure assurance propriétaire non
                      occupant.
                    </li>
                  </ul>
                  <p>Dans quel cas êtes vous ?</p>
                </div>
                <!--timeline event actions links-->
                <div class="timeline__event-actions">
                  <b-link
                    class="timeline__event-action"
                    :to="{ name: 'form-insurance' }"
                    title="MRH"
                    >Résidence</b-link
                  >
                  <b-link
                    class="timeline__event-action"
                    :to="{ name: 'form-insurance' }"
                    title="PNO"
                    >Investissement locatif</b-link
                  >
                </div>
              </div>
            </div>
            <!--timeline element-->
            <div class="timeline__elem timeline__elem--left">
              <!--timeline element date-->
              <div class="timeline__date">
                <IconLightbulb class="white w-50" />
              </div>
              <!--timeline event-->
              <div class="timeline__event">
                <!--timeline event title-->
                <h4 class="timeline__event-title">Energie 💡</h4>
                <!--timeline event descrtiption-->
                <div class="timeline__event-descr">
                  <p>
                    Je souscris chez le fournisseur d'électricité plus vert, plus simple et moins
                    cher.
                  </p>
                </div>
                <!--timeline event actions links-->
                <div class="timeline__event-actions">
                  <a
                    rel="noopener"
                    target="_blank"
                    class="timeline__event-action"
                    title="Bulb"
                    href="https://bulb.fr/?utm_source=teddi&utm_medium=partner&utm_campaign=1"
                    >Souscrire en 2 minutes</a
                  >
                </div>
              </div>
            </div>
            <!--timeline element-->
            <div class="timeline__elem timeline__elem--right">
              <!--timeline element date-->
              <div class="timeline__date">
                <IconCalculator class="white icon" />
              </div>
              <!--timeline event-->
              <div class="timeline__event">
                <!--timeline event title-->
                <h4 class="timeline__event-title">Gestion locative 🧑‍💻</h4>
                <!--timeline event descrtiption-->
                <div class="timeline__event-descr">
                  <p>
                    Assurer la relation avec les locataires, les interventions techniques, les
                    remises en location et les états des lieux prend beaucoup de temps.
                  </p>
                  <p>
                    Comparez les offres des services de gestion locative.
                  </p>
                </div>
                <!--timeline event actions links-->
                <div class="timeline__event-actions">
                  <a
                    class="timeline__event-action"
                    href="mailto:rental@teddi.co?subject=Comparer%20les%20gestionnaires%20locatifs&body=Bonjour%2C%0D%0A%0D%0AJ'aimerais%20comparer%20les%20gestionnaires%20locatifs%20afin%20de%20trouver%20le%20meilleur%20pour%20mettre%20en%20location%20et%2Fou%20g%C3%A9rer%20les%20relations%20avec%20le%20locataire.%0D%0A%0D%0ALes%20caract%C3%A9ristiques%20de%20mon%20bien%20%3A%0D%0A%0D%0A-%20adresse%20%3A%20%0D%0A-%20prix%20%3A%0D%0A-%20surface%20%3A%0D%0A-%20chambres%20%3A%0D%0A-%20%C3%A9tage%20%3A%20%0D%0A%0D%0AMes%20informations%20personnelles%20%3A%0D%0A-%20Mon%20nom%20%3A%0D%0A-%20Mon%20pr%C3%A9nom%20%3A%C2%A0%0D%0A-%20Mon%20num%C3%A9ro%20de%20t%C3%A9l%C3%A9phone%20%3A"
                    title="Gestion locative"
                    >Comparer</a
                  >
                </div>
              </div>
            </div>
            <!--timeline element-->
            <div class="timeline__elem timeline__elem--left">
              <!--timeline element date-->
              <div class="timeline__date">
                <IconCart class="white icon" />
              </div>
              <!--timeline event-->
              <div class="timeline__event">
                <!--timeline event title-->
                <h4 class="timeline__event-title">Mettre en vente 👋</h4>
                <!--timeline event descrtiption-->
                <div class="timeline__event-descr">
                  <p>Vous souhaitez mettre en vente votre appartement ou votre maison ?</p>
                  <ul>
                    <li>
                      <p>
                        <strong class="text-blue">⚡️ Nouveau !</strong>
                      </p>
                      <p>
                        J'ai le temps de m'en occuper : j'envoie mon annonce uniquement à la cible
                        que je définis. C'est
                        <strong class="text-blue">gratuit</strong> ! 🌈
                      </p>
                      <a
                        rel="noopener"
                        target="_blank"
                        href="http://diagnostiqueurs.din.developpement-durable.gouv.fr/index.action"
                        >Besoin d'un DPE ?</a
                      >
                    </li>
                    <li>
                      Je n'ai pas le temps : je compare les agences pour trouver la meilleure.
                    </li>
                  </ul>
                  <p>Que préférez-vous ?</p>
                </div>
                <!--timeline event actions links-->
                <div class="timeline__event-actions">
                  <a
                    class="timeline__event-action"
                    title="Publier"
                    href="mailto:selling@teddi.co?subject=Publier%20gratuitement%20une%20annonce%20sur%20Teddi&body=Bonjour%2C%0D%0A%0D%0AJ'aimerais%20publier%20une%20annonce%20immobili%C3%A8re%20sur%20Teddi%20en%20ciblant%20uniquement%20certains%20profils%20%F0%9F%8C%88%20que%20je%20choisis.%0D%0A%0D%0ALes%20caract%C3%A9ristiques%20de%20mon%20appartement%20ou%20ma%20maison%20%3A%0D%0A%0D%0A-%20adresse%20%3A%20%0D%0A-%20prix%20%3A%0D%0A-%20surface%20%3A%0D%0A-%20chambres%20%3A%0D%0A-%20%C3%A9tage%20%3A%20%0D%0A-%20qualit%C3%A9s%20(mots-cl%C3%A9s)%20%3A%20%0D%0A-%20inconv%C3%A9nients%20(mots-cl%C3%A9s)%20%3A%0D%0A%0D%0ALes%20caract%C3%A9ristiques%20souhait%C3%A9es%20des%20profils%20cibl%C3%A9s%20%3A%0D%0A%0D%0A-%20accord%20de%20principe%20obtenu%20par%20sa%20banque%20%3A%20oui%20%2F%20peu%20importe%0D%0A-%20ach%C3%A8te%20sans%20condition%20suspensive%20%3A%20oui%20%2F%20peu%20importe%0D%0A-%20ach%C3%A8te%20sans%20emprunt%20%3A%20oui%20%2F%20peu%20importe%0D%0A-%20dispose%20d'un%20bien%20%C3%A0%20vendre%20%3A%20oui%20%2F%20peu%20importe%0D%0A%0D%0AJ'aimerais%20recevoir%20les%20demandes%20d'informations%20%0D%0A-%20%C3%A0%20l'email%20suivant%20%3A%0D%0A-%20au%20num%C3%A9ro%20suivant%20%3A%20%0D%0A"
                    >Publier</a
                  >
                  <a
                    class="timeline__event-action"
                    title="Comparer"
                    href="mailto:selling@teddi.co?subject=Comparer%20les%20meilleures%20agences%20immobili%C3%A8res&body=Bonjour%2C%0D%0A%0D%0AJ'aimerais%20comparer%20les%20agences%20immobili%C3%A8res%20afin%20de%20trouver%20la%20meilleure%20pour%20vendre%20mon%20appartement%20ou%20ma%20maison.%0D%0A%0D%0ALes%20caract%C3%A9ristiques%20de%20mon%20bien%20%3A%0D%0A%0D%0A-%20adresse%20%3A%20%0D%0A-%20prix%20%3A%0D%0A-%20surface%20%3A%0D%0A-%20chambres%20%3A%0D%0A-%20%C3%A9tage%20%3A%20%0D%0A-%20qualit%C3%A9s%20(mots-cl%C3%A9s)%20%3A%20%0D%0A-%20inconv%C3%A9nients%20(mots-cl%C3%A9s)%20%3A%0D%0A%0D%0AQuel%20sont%20les%20crit%C3%A8res%20les%20plus%20importants%20dans%20le%20choix%20d'une%20agence%20immobili%C3%A8re%20(classez%20par%20ordre%20de%20priorit%C3%A9)%20%3A%0D%0A%0D%0A1)%20le%20montant%20des%20honoraires%0D%0A2)%20le%20d%C3%A9lai%20moyen%20pour%20vendre%20au%20prix%20choisi%C2%A0%0D%0A3)%20l'accompagnement%20et%20le%20conseil%0D%0A4)%20la%20qualit%C3%A9%20du%20contact%20avec%20le%20professionnel%C2%A0%0D%0A%0D%0AMes%20informations%20personnelles%20%3A%0D%0A-%20Mon%20nom%20%3A%0D%0A-%20Mon%20pr%C3%A9nom%20%3A%C2%A0%0D%0A-%20Mon%20num%C3%A9ro%20de%20t%C3%A9l%C3%A9phone%20%3A"
                    >Comparer</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer />
    <!--MODAL EMAIL-->
    <b-modal
      centered
      @shown="focusMyElement"
      ref="modal-email"
      :hide-header="true"
      :hide-footer="true"
      size="lg"
    >
      <div class="row position-relative mx-auto">
        <div class="col-md-6 bg-blue order-2 order-md-1 d-none d-md-flex border-radius-left px-0">
          <b-img class="w-100 my-auto" alt="bank" :src="require('@/assets/img/partner-bank.png')">
          </b-img>
        </div>
        <div class="col-md-6 my-3 order-1 order-md-2 py-md-5 px-md-5">
          <h4 class="text-blue mb-md-4">Quelle est votre adresse email ?</h4>
          <p class="mb-4 mt-2">
            <strong class="text-blue">Nouveau</strong> ! Soumettez votre demande d'emprunt
            automatiquement auprès de toutes les banques et attendez leurs propositions. C'est
            <strong class="text-blue">gratuit</strong> ! 🌈
          </p>
          <b-input
            ref="focusThis"
            class="my-4 w-75 mx-auto"
            type="text"
            placeholder="helene@teddi.co"
            v-model="partnerBankEmail"
          ></b-input>
          <transition name="fade">
            <div
              class="bg-blue position-absolute"
              v-if="this.partnerBankEmail && this.reg.test(partnerBankEmail)"
              size="sm"
              @click="sendToPartnerBank('timeline')"
            >
              Continuer
            </div>
          </transition>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import IconSearch from "@/components/icons/IconSearch.vue";
import IconCart from "@/components/icons/IconCart.vue";
import IconEdit from "@/components/icons/IconEdit.vue";
import IconWrench from "@/components/icons/IconWrench.vue";
import IconInsurance from "@/components/icons/IconInsurance.vue";
import IconLightbulb from "@/components/icons/IconLightbulb.vue";
import IconDirections from "@/components/icons/IconDirections.vue";
import IconMore from "@/components/icons/IconMore.vue";
import IconCalculator from "@/components/icons/IconCalculator.vue";
import IconMoving from "@/components/icons/IconMoving.vue";
import IconPrice from "@/components/icons/IconPrice.vue";
import IconRuler from "@/components/icons/IconRuler.vue";
import Email from "@/components/content/Email.vue";
import Footer from "@/components/bottom/Footer.vue";
import Vue from "vue";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    IconSearch,
    IconCalculator,
    IconLightbulb,
    Footer,
    IconCart,
    IconEdit,
    IconWrench,
    IconInsurance,
    IconDirections,
    IconMoving,
    IconMore,
    IconPrice,
    IconRuler,
    Email,
  },

  metaInfo: {
    title: "Les étapes d'un achat immobilier",
    titleTemplate: "%s ← Teddi",
    meta: [
      { "http-equiv": "Content-Type", content: "text/html; charset=utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "description",
        content:
          "Tous nos conseils pour vivre les étapes de l'achat immobilier avec les meilleurs partenaires possibles",
      },
      {
        property: "og:title",
        content: "Merci ← Teddi",
      },
      { property: "og:site_name", content: "Teddi" },
      { property: "og:type", content: "website" },
      {
        property: "og:image",
        content: "https://www.teddi.co/assets/socials/fb-cover.jpg",
      },
      {
        property: "og:description",
        content:
          "Tous nos conseils pour vivre les étapes de l'achat immobilier avec les meilleurs partenaires possibles",
      },
    ],
  },
  data() {
    return {
      reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
    };
  },
  computed: {
    ...mapState(["email"]),
    partnerBankEmail: {
      get() {
        return this.$store.state.userData.email;
      },
      set(value) {
        if (value != null && value != "") {
          if (this.reg.test(value)) this.$store.commit("SET_EMAIL", value);
        } else {
          this.$store.commit("SET_EMAIL", null);
        }
      },
    },
  },
  methods: {
    ...mapActions(["sendToPartnerBank"]),
    openModalEmail() {
      this.$refs["modal-email"].show();
    },
    focusMyElement() {
      this.$refs.focusThis.focus();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/timelines.scss";
@import "@/styles/modals.scss";
</style>
